export default {"src":"/_next/static/media/404.db981154.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};